import { FeatureStyle } from "../featuretree/internal";
import { Obj } from "../internal";
import { USERINPUTTYPE } from "../userinput/internal";
import { FrameFeatureCollection } from "./internal";
export class FrameFeatureHandler extends Obj {
    constructor(scene) {
        super();
        this.framefeaturecollections = [];
        this.pickedfeatures = [];
        this._category = "person";
        this.scene = scene;
        this.style = new FeatureStyle({
            stylename: "category",
            rules: [
                {
                    filter: "",
                    symbolizer: "polygon",
                    params: {
                        fill: [0.9568, 0.5137, 0.3372, 0.3],
                        stroke: [0.9568, 0.5137, 0.3372, 0.3],
                    },
                },
            ],
        });
        this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE["GEOFRAMECHANGED"], this.OnGeoFrameChanged, this);
        this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE["IMAGECHANGED"], this.onImageChanged, this);
    }
    OnGeoFrameChanged(geoframe) {
        this.geoframe = geoframe;
        const currentFrameNum = this.geoframe.getFramenumber();
        const currentSegmentId = this.geoframe.segment;
        const currentStreamId = this.geoframe.stream;
        const currentActivimage = this.geoframe.parentGeoFrameCollection.activeimage;
        this.update(currentFrameNum, currentSegmentId, currentStreamId, currentActivimage);
    }
    onImageChanged(activeimage) {
        const currentFrameNum = this.geoframe.framenumber;
        const currentSegmentId = this.geoframe.segment;
        const currentStreamId = this.geoframe.stream;
        this.update(currentFrameNum, currentSegmentId, currentStreamId, activeimage);
    }
    /**
     * create empty FrameFeatureCollection
     * @param name
     * @returns {FrameFeatureCollection}
     */
    createFeatureCollection(name = "") {
        const frameFeatureCollection = new FrameFeatureCollection(this.scene, this.style, name, this);
        this.framefeaturecollections.push(frameFeatureCollection);
        return frameFeatureCollection;
    }
    /**
     * remove and destroy all FrameFeatureCollections (and children) from this Handler
     * @param fc
     */
    removeFeatureCollection(fc) {
        let index = -1;
        for (let i = 0; i < this.framefeaturecollections.length; i++) {
            if (this.framefeaturecollections[i] == fc) {
                this.framefeaturecollections[i].destroy();
                index = i;
            }
        }
        if (index >= 0)
            this.framefeaturecollections.splice(index, 1);
    }
    /**
     * triggers update in every FrameFeature in a Collection of this Handler
     *
     * @param currentFrameNum
     * @param currentSegmentId
     * @param currentStreamId
     */
    update(currentFrameNum, currentSegmentId, currentStreamId, activeimage) {
        for (let i = 0; i < this.framefeaturecollections.length; i++) {
            this.framefeaturecollections[i].update(currentFrameNum, currentSegmentId, currentStreamId, activeimage);
        }
    }
    parseFromJSON(geojson, name) {
        let new_ffc = null;
        let geojsonObject = null;
        if (typeof geojson == typeof String()) {
            geojsonObject = JSON.parse(geojson);
        }
        else {
            geojsonObject = geojson;
        }
        if (geojsonObject["type"] == "FeatureCollection") {
            new_ffc = new FrameFeatureCollection(this.scene, this.style, name, this);
            new_ffc.parseFromJSON(geojsonObject);
        }
        this.framefeaturecollections.push(new_ffc);
        return new_ffc;
    }
    toGeoJsonString() {
        let jsonstring = "[";
        for (let i = 0; i < this.framefeaturecollections.length; i++) {
            jsonstring += this.framefeaturecollections[i].toGeoJsonString();
            if (i < this.framefeaturecollections.length - 1)
                jsonstring += ",";
        }
        jsonstring += "]";
        return jsonstring;
    }
    /**
     * find FrameFeatures at mx,my pos in every or a given Collection of this Handler
     *
     * @param mx
     * @param my
     * @param picklayer
     * @returns {Array}
     */
    pick(mx, my, picklayer) {
        const pickedfeatures = [];
        if (picklayer) {
            picklayer.pick(mx, my, pickedfeatures);
        }
        else {
            for (let i = 0; i < this.framefeaturecollections.length; i++) {
                this.framefeaturecollections[i].pick(mx, my, pickedfeatures);
            }
        }
        return pickedfeatures;
    }
    highlightOff() {
        for (let i = 0; i < this.framefeaturecollections.length; i++) {
            this.framefeaturecollections[i].highlightOff();
        }
    }
    setCategory(category) {
        this._category = category;
    }
    getCategory() {
        return this._category;
    }
    /**
     * load Category - Color relations from a valid json
     *
     * @param json
     * @deprecated
     */
    loadColorCategory(json) {
        const colorCategory = JSON.parse(json);
        this._createStyleFromColorCategory(colorCategory);
    }
    _createStyleFromColorCategory(colorCategory) {
        const rules = [];
        for (const category in colorCategory) {
            const rule = {
                filter: "category==" + category,
                symbolizer: "polygon",
                params: {
                    fill: FrameFeatureHandler.hexToRgbaArray(colorCategory[category]["color"]),
                },
            };
            rules.push(rule);
        }
        this.style = new FeatureStyle({
            stylename: "category",
            rules: rules,
        });
        this.framefeaturecollections.forEach(function (ffc) {
            ffc.changeStyle(this.style);
        }, this);
    }
    static hexToRgbaArray(hex) {
        let result = /^0x?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        if (!result)
            result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result
            ? [parseInt(result[1], 16) / 255, parseInt(result[2], 16) / 255, parseInt(result[3], 16) / 255, 0.7]
            : null;
    }
}
//# sourceMappingURL=framefeaturehandler.js.map